module.exports = __webpack_public_path__ + "static/media/Firefly_Logo_White.16060f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Firefly_Logo_White.png
// module id = 78
// module chunks = 0